export default {
  header: 'IntroBold',
  subheader: 'TradeGothic',
  normal: 'WorkSans',
}
